module.exports = __webpack_public_path__ + "static/media/original.b8503d26.png";